import React from 'react';
import Slider from 'react-slick';
import './ourclient.css'; // Import your custom CSS file

// Client logos (replace with your actual image paths)
import raymond from '../../assets/clients/raymond.jpeg';
import digigram from '../../assets/clients/digjam.jpeg';
import honda from '../../assets/clients/honda.png';
import hyundai from '../../assets/clients/hyundai.png';
import poorvika from '../../assets/clients/poorvika.png';
import nexa from '../../assets/clients/nexa.png';
import sujana from "../../assets/clients/sujana.jpeg";
import maruthi from "../../assets/clients/maruthi.jpeg";
import surana from "../../assets/clients/surana.jpeg";
import tcs from "../../assets/clients/tcs.jpeg";
import kalyani from "../../assets/clients/kalyani.jpeg";


function OurClients() {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: true, // Enable auto sliding
        autoplaySpeed: 3000, // Slide every 3 seconds
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <section className="our-clients-section">


            <div className="our-clients">
              <div className="section-title clearfix d-flex flex-column align-items-center">
                <div class="title-header">
                    <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>our clients</h5>
                    {/* <h3>New Sky Property & Projects Private Limited (NSPP)</h3> */}
                </div>
                <div className='underline' style={{ width:"8%"}} ></div>
            </div>

                <Slider {...settings}>
                    <div className="client-item">
                        <img src={honda} alt="Honda" />
                    </div>
                    <div className="client-item">
                        <img src={digigram} alt="Digigram" />
                    </div>
                    <div className="client-item">
                        <img src={nexa} alt="Nexa" />
                    </div>
                    <div className="client-item">
                        <img src={raymond} alt="Raymond" />
                    </div>
                    <div className="client-item">
                        <img src={hyundai} alt="Hyundai" />
                    </div>
                    <div className="client-item">
                        <img src={poorvika} alt="Poorvika" />
                    </div>
                    <div className="client-item">
                        <img src={sujana} alt="Kia" />
                    </div>
                    <div className="client-item">
                        <img src={maruthi} alt="Kia" />
                    </div>
                    {/* <div className="client-item">
              <img src={surana} alt="Kia" />
            </div> */}
                    <div className="client-item">
                        <img src={tcs} alt="Kia" />
                    </div>
                    <div className="client-item">
                        <img src={kalyani} alt="Kia" />
                    </div>
                </Slider>
            </div>

        </section>
    );
}

export default OurClients;
